import Box from '@mui/material/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import IconButton from '@material-ui/core/IconButton';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import { TOUR_BANNER, TOUR_BANNER_MOBILE } from 'constants/Images';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import styles from './styles.module.css';

export default function ModalTour({ open, handleCloseModal, handleConfirmModal, mobile = false, defaultSteps = [], stepsFinish }) {
  const checkIsShow = (key) => {
    if (stepsFinish && stepsFinish?.length > 0) {
      const filterArr = defaultSteps?.filter((item) => !stepsFinish.includes(item));
      return filterArr?.some((item) => item === key) || false;
    }
    return defaultSteps.some((item) => item === key);
  };
  const handleClose = () => {
    handleCloseModal();
  };
  const handleConfirm = () => {
    handleConfirmModal();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className={clsx(mobile ? styles.styleMobile : styles.styleDesktop)}>
          <div className={styles.banner}>
            <IconButton aria-label="close" className={styles.closeButton} onClick={handleClose}>
              <CloseIcon />
            </IconButton>
            <ImageFallbackStatic
              src={mobile ? TOUR_BANNER_MOBILE : TOUR_BANNER}
              alt="Thuocsi Logo New"
              objectFit="contain"
              width={mobile ? 150 : 700}
              height={mobile ? 150 : 234}
              layout="fixed"
            />
          </div>
          <div className={styles.content}>
            <div className={styles.titleContainer}>
              <Typography className={styles.title}>Giao diện</Typography>
              <Typography className={styles.title}>Chi tiết sản phẩm mới</Typography>
            </div>

            <div className={styles.groupContent}>
              <Typography className={styles.new}>Mới:</Typography>
              <ul>
                {checkIsShow('productsSame') && <li>Các nhà bán hàng khác cũng bán sản phẩm này</li>}
                {checkIsShow('productsDeal') && <li>Mua kèm deal sốc</li>}
                {checkIsShow('addToCart') && <li>Nút mua hàng</li>}
                {checkIsShow('infoProduct') && <li>Thông tin sản phẩm</li>}
              </ul>
            </div>
          </div>
          <div className={styles.groupButton}>
            <ButtonBase className={styles.understand} onClick={handleClose}>
              Tôi đã hiểu
            </ButtonBase>
            <ButtonBase className={styles.try} onClick={handleConfirm}>
              Trải nghiệm ngay
            </ButtonBase>
          </div>
        </Box>
      </Modal>
    </ClickAwayListener>
  );
}
